require("source-map-support").install(), function (e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define("Logo", [], r) : "object" == typeof exports ? exports.Logo = r() : e.Logo = r();
}(this, function () {
  return function (e) {
    var r = {};

    function n(t) {
      if (r[t]) return r[t].exports;
      var a = r[t] = {
        i: t,
        l: !1,
        exports: {}
      };
      return e[t].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
    }

    return n.m = e, n.c = r, n.d = function (e, r, t) {
      n.o(e, r) || Object.defineProperty(e, r, {
        enumerable: !0,
        get: t
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, r) {
      if (1 & r && (e = n(e)), 8 & r) return e;
      if (4 & r && "object" == typeof e && e && e.__esModule) return e;
      var t = Object.create(null);
      if (n.r(t), Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
      }), 2 & r && "string" != typeof e) for (var a in e) {
        n.d(t, a, function (r) {
          return e[r];
        }.bind(null, a));
      }
      return t;
    }, n.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(r, "a", r), r;
    }, n.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }, n.p = "/", n(n.s = 377);
  }({
    0: function _(e, r) {
      e.exports = require("react");
    },
    2: function _(e, r) {
      e.exports = require("styled-components");
    },
    272: function _(e, r, n) {
      "use strict";

      n.r(r);
      var t = n(3),
          a = n.n(t),
          c = n(0),
          o = n.n(c),
          u = n(2),
          i = n.n(u),
          s = n(5);

      function l() {
        var e = a()(["\n  line-height: 0;\n  \n  g {\n    fill: ", ";\n    fill-rule: evenodd;\n  }\n"]);
        return l = function l() {
          return e;
        }, e;
      }

      var f = i.a.div(l(), function (e) {
        var r = e.uistyle,
            n = e.theme.colors;
        return Object(s.e)(r, n);
      }),
          d = function d(e) {
        var r = e.uistyle;
        return o.a.createElement(f, {
          uistyle: r
        }, o.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "400",
          height: "74",
          viewBox: "0 0 400 74"
        }, o.a.createElement("g", null, o.a.createElement("path", {
          d: "M89.899 20.558c2.259-1.943 4.113-2.588 7.014-2.588 1.132.017 2.263.098 3.386.244v8.253c-1.45-.082-2.501-.163-3.305-.163-5.321 0-7.095 2.588-7.095 10.52v17.237h-9.192V18.213H89.9v2.345z"
        }), o.a.createElement("path", {
          fillRule: "nonzero",
          d: "M138.792 36.094c0 10.764-8.303 19.18-18.946 19.18-10.804 0-19.026-8.416-19.026-19.342 0-10.678 8.384-18.935 19.269-18.935 10.416 0 18.703 8.496 18.703 19.097zm-28.687 0c0 6.396 3.948 10.845 9.754 10.845 5.725 0 9.672-4.461 9.672-10.845 0-6.31-3.947-10.759-9.51-10.759-5.98 0-9.928 4.27-9.928 10.76h.012z"
        }), o.a.createElement("path", {
          d: "M152.412 42.49c0 2.669.404 3.48 1.774 3.48.808 0 2.178-.244 4.275-.811v8.658c-2.34.65-3.79.892-5.322.892-6.367 0-9.915-4.371-9.915-12.219V26.548h-3.709v-8.334h3.71v-7.67l9.187-3.65v11.32h5.483v8.334h-5.483V42.49z"
        }), o.a.createElement("path", {
          fillRule: "nonzero",
          d: "M188.19 54.06v-2.267c-3.305 2.51-5.887 3.48-9.592 3.48-10.48 0-18.784-8.496-18.784-19.179 0-10.6 8.303-19.097 18.784-19.097 3.705 0 6.287.973 9.592 3.48v-2.264h9.192v35.848h-9.192zm-19.107-17.966c0 6.396 3.951 10.845 9.673 10.845 5.656 0 9.596-4.461 9.596-10.845 0-6.31-3.871-10.759-9.354-10.759-5.964 0-9.915 4.27-9.915 10.76z"
        }), o.a.createElement("path", {
          d: "M213.034 20.558c2.255-1.943 4.11-2.588 7.014-2.588 1.133.017 2.263.098 3.386.244v8.253c-1.45-.082-2.5-.163-3.305-.163-5.32 0-7.095 2.588-7.095 10.52v17.237h-9.192V18.213h9.192v2.345z"
        }), o.a.createElement("path", {
          fillRule: "nonzero",
          d: "M233.386 39.574c1.293 4.778 4.444 7.365 8.95 7.365 2.981 0 5.725-1.05 7.58-2.993.403-.324.965-1.217 1.854-2.51l7.737 3.244c-2.254 3.885-2.982 4.696-5.252 6.558a19.347 19.347 0 0 1-11.932 4.055c-10.4 0-18.38-8.334-18.38-19.178 0-10.679 7.98-19.098 18.057-19.098 7.822 0 14.432 5.098 16.772 12.868.668 2.314.994 4.713.965 7.122 0 .564 0 1.217-.08 2.587l-26.271-.02zm17.172-6.894c-1.617-5.098-4.352-7.523-8.546-7.523-4.351 0-7.414 2.75-8.626 7.523h17.172zM290.384 54.06v-2.267c-3.305 2.51-5.887 3.48-9.596 3.48-10.48 0-18.784-8.496-18.784-19.179 0-10.6 8.303-19.097 18.784-19.097 3.709 0 6.29.973 9.596 3.48v-2.264h9.188v35.848h-9.188zm-19.107-17.966c0 6.396 3.947 10.845 9.672 10.845 5.657 0 9.596-4.461 9.596-10.845 0-6.31-3.87-10.759-9.353-10.759-5.968 0-9.915 4.27-9.915 10.76zM332.259 54.06v-2.267c-3.305 2.51-5.883 3.48-9.592 3.48-10.481 0-18.784-8.496-18.784-19.179 0-10.6 8.303-19.097 18.784-19.097 3.709 0 6.287.973 9.592 3.48V.085h9.192v53.976h-9.192zm-19.107-17.966c0 6.396 3.951 10.845 9.696 10.845 5.657 0 9.512-4.461 9.512-10.845 0-6.31-3.867-10.759-9.35-10.759-5.907 0-9.858 4.27-9.858 10.76z"
        }), o.a.createElement("path", {
          d: "M343.366 18.213h9.996l9.676 22.898 10.077-22.897h9.915l-24.266 54.7h-9.754l9.107-20.553z"
        }), o.a.createElement("path", {
          fillRule: "nonzero",
          d: "M395.556 1.456a8.866 8.866 0 0 1 3.232 3.277 8.951 8.951 0 0 1 0 8.922c-2.455 4.251-7.865 5.721-12.121 3.293a8.804 8.804 0 0 1-3.265-3.277 9.037 9.037 0 0 1-1.212-4.542 8.587 8.587 0 0 1 2.953-6.566 8.725 8.725 0 0 1 6.09-2.308 8.324 8.324 0 0 1 4.323 1.2zm-7.976 1.622a7.222 7.222 0 0 0-2.574 2.584 7.076 7.076 0 0 0-.712 5.364 7.05 7.05 0 0 0 3.286 4.292 6.963 6.963 0 0 0 7.046 0 6.857 6.857 0 0 0 2.586-2.571 7.085 7.085 0 0 0 .942-3.598 6.768 6.768 0 0 0-2.332-5.19 6.927 6.927 0 0 0-4.848-1.826c-1.2-.004-2.38.32-3.41.937l.016.008zm8.186 11.445h-2.449l-2.161-3.89c-.194 0-.38.025-.554.025h-.493v3.865h-2.194V3.889h2.687c1.426 0 2.279.244 2.978.844a3.217 3.217 0 0 1 1.143 2.567 3.113 3.113 0 0 1-1.483 2.746l2.526 4.477zm-5.657-5.93h.634c1.253 0 1.815-.405 1.815-1.301 0-.896-.562-1.326-1.815-1.326h-.634v2.628z"
        }), o.a.createElement("path", {
          d: "M70.51 51.177l-6.175-2.433a28.974 28.974 0 0 0-1.192-4.49l4.134-5.19c.382-.478.433-1.141.13-1.672l-1.484-2.575a1.473 1.473 0 0 0-1.507-.726l-6.55 1.002a29.433 29.433 0 0 0-3.268-3.281l.998-6.578a1.498 1.498 0 0 0-.727-1.513l-2.562-1.484a1.478 1.478 0 0 0-1.669.125l-5.167 4.17a28.49 28.49 0 0 0-4.473-1.217l-2.424-6.197a1.483 1.483 0 0 0-1.382-.95h-2.946a1.487 1.487 0 0 0-1.381.95l-2.425 6.197a28.49 28.49 0 0 0-4.472 1.216l-5.156-4.152a1.478 1.478 0 0 0-1.669-.126l-2.577 1.484a1.498 1.498 0 0 0-.728 1.513l1.002 6.578a29.433 29.433 0 0 0-3.268 3.28l-6.538-1a1.473 1.473 0 0 0-1.507.725L4.04 37.408a1.489 1.489 0 0 0 .13 1.671l4.133 5.191a28.974 28.974 0 0 0-1.192 4.49L.937 51.193c-.56.224-.93.766-.937 1.371v1.484h19.046a16.753 16.753 0 0 1 8.34-14.498 16.625 16.625 0 0 1 16.679 0 16.753 16.753 0 0 1 8.339 14.498h19.047v-1.484c-.001-.612-.374-1.162-.942-1.387z"
        }))));
      };

      d.defaultProps = {
        uistyle: "primary"
      };
      var h = d;
      r.default = h;
    },
    3: function _(e, r) {
      e.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
    },
    377: function _(e, r, n) {
      e.exports = n(272);
    },
    4: function _(e) {
      e.exports = JSON.parse('{"white":"#ffffff","brand":"#0d51ff","brand10":"#e6edff","brand20":"#c5d2f5","brand40":"#96b1f7","brand60":"#6992fa","brand80":"#3a71fc","brand120":"#0a40cc","brand140":"#073099","brand160":"#052066","brand180":"#021033","grey":"#475b68","grey10":"#f8f8f8","grey20":"#f0f0f0","grey40":"#bbc3ca","grey60":"#919da4","grey80":"#6c7c86","grey120":"#384853","grey140":"#2a363e","grey160":"#1c2429","grey180":"#0e1214","success":"#00ab5b","successhover":"#008848","successlight":"#66cd9d","successbackground":"#e5f6ee","warninghover":"#cc9c00","warning":"#ffc400","warninglight":"#ffdc66","warningabsence":"#ffedb2","warningbackground":"#fff9e6","alerthover":"#cc180b","alert":"#ff1e0e","alertlight":"#ff786e","alertbackground":"#ffe8e6","infohover":"#b01863","info":"#dc1e7c","infolight":"#ea78b0","infobackground":"#fbe8f2","supporthover":"#583ac3","support":"#6e49f4","supportlight":"#a892f8","supportbackground":"#f0ecfe","boxshadowmedium":"rgba(71, 91, 104, 0.1)","modaloverlay":"rgba(2, 16, 51, 0.5)","transparent":"transparent"}');
    },
    5: function _(e, r, n) {
      "use strict";

      n.d(r, "a", function () {
        return v;
      }), n.d(r, "e", function () {
        return c;
      }), n.d(r, "j", function () {
        return o;
      }), n.d(r, "f", function () {
        return u;
      }), n.d(r, "g", function () {
        return i;
      }), n.d(r, "i", function () {
        return f;
      }), n.d(r, "c", function () {
        return d;
      }), n.d(r, "k", function () {
        return d;
      }), n.d(r, "l", function () {
        return h;
      }), n.d(r, "b", function () {
        return p;
      }), n.d(r, "d", function () {
        return g;
      }), n.d(r, "h", function () {
        return l;
      });

      var t = n(4),
          a = n(9),
          c = function c(e) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "primary":
            return r.brand;

          case "secondary":
          case "normal":
          default:
            return r.grey;

          case "info":
            return r.info;

          case "support":
            return r.support;

          case "success":
            return r.success;

          case "warning":
            return r.warning;

          case "alert":
            return r.alert;

          case "brand160":
            return r.brand160;

          case "white":
            return r.white;
        }
      },
          o = function o(e) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "primary":
            return r.brand60;

          case "secondary":
          case "normal":
          default:
            return r.grey40;

          case "info":
            return r.infolight;

          case "support":
            return r.supportlight;

          case "success":
            return r.successlight;

          case "warning":
            return r.warninglight;

          case "alert":
            return r.alertlight;

          case "grey20":
          case "white":
            return r.grey20;
        }
      },
          u = function u(e) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "primary":
            return r.brand120;

          case "secondary":
          case "normal":
          default:
            return r.grey140;

          case "info":
            return r.infohover;

          case "support":
            return r.supporthover;

          case "success":
            return r.successhover;

          case "warning":
            return r.warninghover;

          case "alert":
            return r.alerthover;

          case "white":
            return r.grey20;
        }
      },
          i = function i(e) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : a;

        switch (e) {
          case "xxs":
            return r.Body4;

          case "xs":
            return r.Body3;

          case "sm":
            return r.Body2;

          case "md":
          default:
            return r.Body1;

          case "lg":
            return r.H5;

          case "xl":
            return r.H4;

          case "xxl":
            return r.H3;

          case "xxxl":
            return r.H2;

          case "xxxxl":
            return r.H1;
        }
      },
          s = Object.freeze({
        xs: 24,
        sm: 30,
        md: 40,
        lg: 50
      }),
          l = function l(e) {
        return s[e] || s.md;
      },
          f = function f(e, r) {
        var n = {
          padding: {
            vertical: 0,
            horizontal: 10
          },
          font: {},
          supportFont: {},
          height: 0
        };

        switch (e) {
          case "xs":
            n.padding.vertical = 6, n.font = r.Body3, n.supportFont = r.Body4;
            break;

          case "sm":
            n.padding.vertical = 8, n.font = r.Body1, n.supportFont = r.Body3;
            break;

          default:
          case "md":
            n.padding.vertical = 12, n.font = r.Body1, n.supportFont = r.Body3;
            break;

          case "lg":
            n.padding.vertical = 17, n.font = r.Body1, n.supportFont = r.Body3;
        }

        return n.height = l(e), n;
      },
          d = function d(e) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "primary":
            return r.brand10;

          case "info":
            return r.infobackground;

          case "support":
            return r.supportbackground;

          case "success":
            return r.successbackground;

          case "warning":
            return r.warningbackground;

          case "alert":
            return r.alertbackground;

          case "normal":
          default:
            return r.white;
        }
      },
          h = function h(e) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "warning":
            return r.brand160;

          case "info":
          case "support":
          case "success":
          case "alert":
          default:
            return r.white;
        }
      },
          p = function p(e) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "info":
            return r.info;

          case "support":
            return r.support;

          case "success":
            return r.success;

          case "warning":
            return r.warning;

          case "alert":
            return r.alert;

          default:
            return r.brand;
        }
      },
          g = function g(e) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "info":
            return r.info;

          case "support":
            return r.support;

          case "success":
            return r.success;

          case "warning":
            return r.warning;

          case "alert":
            return r.alert;

          default:
            return r.brand;
        }
      },
          v = new Map([[0, "rgb(110,73,244)"], [1, "#098256"], [2, "#7300B3"], [3, "#052066"], [4, "#6E49F4"], [5, "#0A40CC"], [6, "#FFB300"], [7, "#FF1E0E"], [8, "#038F00"], [9, "#CC34AF"], [10, "#11AEEF"], [11, "#475B68"], [12, "#DC1E7C"], [13, "#30C881"], [14, "#FF6A12"], [15, "#2D9898"]]);
    },
    9: function _(e) {
      e.exports = JSON.parse('{"H1":{"fontFamily":"URWGeometric","fontSize":46,"lineHeight":64},"H2":{"fontFamily":"URWGeometric","fontSize":38,"lineHeight":54},"H3":{"fontFamily":"URWGeometric","fontSize":26,"lineHeight":36},"H4":{"fontFamily":"URWGeometric","fontSize":20,"lineHeight":28},"H5":{"fontFamily":"URWGeometric","fontSize":18,"lineHeight":26},"Body1":{"fontFamily":"URWGeometric","fontSize":16,"lineHeight":22},"Body2":{"fontFamily":"URWGeometric","fontSize":14,"lineHeight":20},"Body3":{"fontFamily":"URWGeometric","fontSize":12,"lineHeight":16},"Body4":{"fontFamily":"URWGeometric","fontSize":10,"lineHeight":14}}');
    }
  });
});